import React from 'react'
import moment from 'moment'

export const TimeAgoIfRecent = ({date, format, minDays = 7}) => {
  const createdMoment = moment(date);
  return createdMoment.isAfter(moment().subtract(minDays, 'days')) 
  ? createdMoment.fromNow()
  : <span>{
      createdMoment.isAfter(moment().subtract(1, 'year')) ?
        createdMoment.format(format || 'MMM D') :
        createdMoment.format(format || 'MMM D Y')
    }</span>

}

